import { NgModule } from '@angular/core';

import { LegalRoutingModule } from './legal-routing.module';
import { LegalComponent } from './legal.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/app/belender/page-layout/page-layout.module';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/modules/materia.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';


@NgModule({
  declarations: [LegalComponent],
  imports: [
    CommonModule,
    LegalRoutingModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    MaterialModule,
    MatDialogModule
  ],
  providers: [
    CustomizationService,
  ],
})
export class LegalModule { }
